export default {
  getWalletId: (state) => state.wallets.length,
};
